import { render, staticRenderFns } from "./SummaryDashboard.vue?vue&type=template&id=ca9d778a"
import script from "./SummaryDashboard.vue?vue&type=script&lang=js"
export * from "./SummaryDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports